import React from 'react';
import PropTypes from 'prop-types';
import '../scss/kiosk.scss';
import RouteOptionsContainer from 'Components/common/RouteOptions/RouteOptionsContainer';

const Directions = props => (
    <div id="kiosk-directions">
        {!props.hideTitle && <h4>Directions</h4>}
        <RouteOptionsContainer isKiosk className="route-options-panel" {...props} />
    </div>
);

Directions.propTypes = {
    hideTitle: PropTypes.bool,
};

export default Directions;
